import { getUniqueId } from '@ankr.com/utils/getUniqueId';

export const stakeCacheTags = {
  stake: `stake-${getUniqueId()}`,
};
